import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export const useMapModeRedirect = () => {
  const isMapMode = useSelector((state: any) => state.mapMode?.isMapMode || false);
  const location = useLocation();

  // Return the effective route for components that need to know
  return {
    isMapMode,
    effectiveRoute: isMapMode && location.pathname === '/home' ? '/village' : location.pathname
  };
}; 